import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Row } from "react-bootstrap";
import { Redirect } from "react-router";
import { SliderPage } from ".";
import { useStockPhotos } from "../context/StockPhotosContext";
import { getClasses } from "../helpers/getClasses";
import { useWatch } from "react-hook-form";
import { ThumbnailCheckbox } from "../components/fields";

const StockArea = ({ area, individual_price }) => {
  const [showAll, setShowAll] = useState(false);
  const { distance, name, stock_images } = area;
  const { length } = stock_images;
  const showLength = showAll ? length : 6;
  const selected_photos = useWatch({ name: "stock_photos" });

  return (
    <div className="stock-area">
      <div className="mb-3">
        <span className="h3 mr-3">{name}</span>
        <small
          className="text-muted"
          style={{
            fontSize: "1rem",
            display: "inline-block",
          }}
        >
          <FontAwesomeIcon icon={["fal", "ruler"]} /> {distance} Away
        </small>
      </div>

      <Row>
        {stock_images.slice(0, showLength).map((image) => {
          const index = selected_photos.indexOf(image.id.toString());
          const selected = index >= 0;
          const free = selected && (index + 1) % 5 === 0;
          const nextFree = !selected && selected_photos.length % 5 === 4;
          let text = "";
          if (free || nextFree) {
            text = "Free";
          } else {
            text = `${selected ? "-" : "+"}` + individual_price;
          }
          return (
            <ThumbnailCheckbox
              key={image.id}
              image={image}
              className={getClasses([free && "free"])}
              selected={selected}
              overlay_text={text}
            />
          );
        })}
      </Row>
      {showLength < length && (
        <Button className="mb-3" onClick={() => setShowAll(true)}>
          Show {length - showLength} More
        </Button>
      )}
    </div>
  );
};

const StockPhotoPage = () => {
  const { stock_regions, individual_price } = useStockPhotos();

  if (!stock_regions) return <Redirect to="/photos" />;
  return (
    <SliderPage title="Stock Photography">
      <p>
        Add great shots from the surrounding area from our extensive and
        affordable stock photo library. <br />
        <strong>{`Only ${individual_price} each! Buy 4 and get the 5th free!`}</strong>
      </p>
      {stock_regions.map((area) => (
        <StockArea
          area={area}
          key={area.id}
          // selected_photos={stock_photos}
          individual_price={individual_price}
        />
      ))}
    </SliderPage>
  );
};

export default StockPhotoPage;
